module.exports = __webpack_public_path__ + "img/happy-holidays-background.2782192f.jpg";